import { render, staticRenderFns } from "./AboutVideoBlock.vue?vue&type=template&id=6ee59647&scoped=true&lang=pug&"
import script from "./AboutVideoBlock.vue?vue&type=script&lang=js&"
export * from "./AboutVideoBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutVideoBlock.vue?vue&type=style&index=0&id=6ee59647&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee59647",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee59647')) {
      api.createRecord('6ee59647', component.options)
    } else {
      api.reload('6ee59647', component.options)
    }
    module.hot.accept("./AboutVideoBlock.vue?vue&type=template&id=6ee59647&scoped=true&lang=pug&", function () {
      api.rerender('6ee59647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/AboutVideoBlock.vue"
export default component.exports